module.exports = __webpack_public_path__ + "img/mq2.3ba34cf7.png";